export default "__VITE_ASSET__9d2142d9__"